import { render, staticRenderFns } from "./GetInTouchModal.vue?vue&type=template&id=121962a5&scoped=true&lang=pug&"
import script from "./GetInTouchModal.vue?vue&type=script&lang=js&"
export * from "./GetInTouchModal.vue?vue&type=script&lang=js&"
import style0 from "./GetInTouchModal.vue?vue&type=style&index=0&id=121962a5&prod&lang=scss&"
import style1 from "./GetInTouchModal.vue?vue&type=style&index=1&id=121962a5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121962a5",
  null
  
)

export default component.exports